const geojsonData = {
  type: "FeatureCollection",

  features: [
    {
      type: "Feature",
      id: "sm96c95c4b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.037855918, 40.580037495],
            [-74.039699363, 40.586575109],
            [-74.044339118, 40.585789968],
            [-74.041163382, 40.579499548],
            [-74.037855918, 40.580037495],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2833",
      },
    },
    {
      type: "Feature",
      id: "smbffb54da",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.023824595, 40.589261374],
            [-74.021952945, 40.582623998],
            [-74.018718657, 40.583150019],
            [-74.018032012, 40.584030013],
            [-74.019576964, 40.589114199],
            [-74.020649848, 40.589798579],
            [-74.023824595, 40.589261374],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2838",
      },
    },
    {
      type: "Feature",
      id: "sm120b7ab9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021952945, 40.582623998],
            [-74.023824595, 40.589261374],
            [-74.027932263, 40.588566301],
            [-74.026067912, 40.581954738],
            [-74.021952945, 40.582623998],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2837",
      },
    },
    {
      type: "Feature",
      id: "smf6d1851f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.026067912, 40.581954738],
            [-74.027932263, 40.588566301],
            [-74.03172979, 40.587923702],
            [-74.029872185, 40.581336004],
            [-74.026067912, 40.581954738],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2836",
      },
    },
    {
      type: "Feature",
      id: "smedcb20f9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.029872185, 40.581336004],
            [-74.03172979, 40.587923702],
            [-74.035620985, 40.587265246],
            [-74.033770294, 40.580702002],
            [-74.029872185, 40.581336004],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2835",
      },
    },
    {
      type: "Feature",
      id: "sm5b850f5f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.033770294, 40.580702002],
            [-74.035620985, 40.587265246],
            [-74.039699363, 40.586575109],
            [-74.037855918, 40.580037495],
            [-74.033770294, 40.580702002],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2834",
      },
    },
    {
      type: "Feature",
      id: "smd1ee823f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.992365876, 40.594420424],
            [-73.990435448, 40.587922273],
            [-73.987948352, 40.588348347],
            [-73.987154422, 40.589342327],
            [-73.987669406, 40.591933148],
            [-73.988356052, 40.595077848],
            [-73.992365876, 40.594420424],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2845",
      },
    },
    {
      type: "Feature",
      id: "sm250859e0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.990435448, 40.587922273],
            [-73.992365876, 40.594420424],
            [-73.996526425, 40.593738282],
            [-73.99458736, 40.587210988],
            [-73.990435448, 40.587922273],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2844",
      },
    },
    {
      type: "Feature",
      id: "sm6a32836a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.99458736, 40.587210988],
            [-73.996526425, 40.593738282],
            [-74.000473408, 40.593091148],
            [-73.998526149, 40.586536206],
            [-73.99458736, 40.587210988],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2843",
      },
    },
    {
      type: "Feature",
      id: "smdc9fee17",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.998526149, 40.586536206],
            [-74.000473408, 40.593091148],
            [-74.004496723, 40.592431493],
            [-74.002541111, 40.585848368],
            [-73.998526149, 40.586536206],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2842",
      },
    },
    {
      type: "Feature",
      id: "sma80c7248",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.002541111, 40.585848368],
            [-74.004496723, 40.592431493],
            [-74.008427723, 40.591786967],
            [-74.00646395, 40.585176305],
            [-74.002541111, 40.585848368],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2841",
      },
    },
    {
      type: "Feature",
      id: "sm14893112",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00646395, 40.585176305],
            [-74.008427723, 40.591786967],
            [-74.012369195, 40.591140718],
            [-74.010397238, 40.584502445],
            [-74.00646395, 40.585176305],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2840",
      },
    },
    {
      type: "Feature",
      id: "sm88c3d490",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010397238, 40.584502445],
            [-74.012369195, 40.591140718],
            [-74.015585838, 40.590613308],
            [-74.016272483, 40.589831168],
            [-74.014684616, 40.584616669],
            [-74.013440066, 40.583981136],
            [-74.010397238, 40.584502445],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2839",
      },
    },
    {
      type: "Feature",
      id: "sm72466053",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020769205, 40.599319568],
            [-74.028440657, 40.597049305],
            [-74.026935562, 40.594117062],
            [-74.01926411, 40.596387424],
            [-74.020769205, 40.599319568],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2935",
      },
    },
    {
      type: "Feature",
      id: "sm082c63dc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.028440657, 40.597049305],
            [-74.020769205, 40.599319568],
            [-74.022320159, 40.602340917],
            [-74.029991612, 40.600070758],
            [-74.028440657, 40.597049305],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2934",
      },
    },
    {
      type: "Feature",
      id: "sm8ac89477",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.029991612, 40.600070758],
            [-74.022320159, 40.602340917],
            [-74.023876029, 40.605371705],
            [-74.031547481, 40.603101648],
            [-74.029991612, 40.600070758],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2933",
      },
    },
    {
      type: "Feature",
      id: "smdd5ccc70",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031547481, 40.603101648],
            [-74.023876029, 40.605371705],
            [-74.025388111, 40.608317065],
            [-74.033059564, 40.606047108],
            [-74.031547481, 40.603101648],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2932",
      },
    },
    {
      type: "Feature",
      id: "sma872e205",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.033059564, 40.606047108],
            [-74.025388111, 40.608317065],
            [-74.026964679, 40.611387897],
            [-74.034636132, 40.609118044],
            [-74.033059564, 40.606047108],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2931",
      },
    },
    {
      type: "Feature",
      id: "sm68c2ad8f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.034636132, 40.609118044],
            [-74.026964679, 40.611387897],
            [-74.028486592, 40.614352139],
            [-74.036158045, 40.612082387],
            [-74.034636132, 40.609118044],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2930",
      },
    },
    {
      type: "Feature",
      id: "sm37234314",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036158045, 40.612082387],
            [-74.028486592, 40.614352139],
            [-74.030005077, 40.617309573],
            [-74.03767653, 40.615039922],
            [-74.036158045, 40.612082387],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2929",
      },
    },
    {
      type: "Feature",
      id: "smd6ff3c73",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.03767653, 40.615039922],
            [-74.030005077, 40.617309573],
            [-74.031592964, 40.620402036],
            [-74.039264417, 40.61813249],
            [-74.03767653, 40.615039922],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2928",
      },
    },
    {
      type: "Feature",
      id: "smd72c487f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.039264417, 40.61813249],
            [-74.031592964, 40.620402036],
            [-74.033109962, 40.623356305],
            [-74.040781415, 40.62108686],
            [-74.039264417, 40.61813249],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2927",
      },
    },
    {
      type: "Feature",
      id: "smcbabb4f7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040781415, 40.62108686],
            [-74.033109962, 40.623356305],
            [-74.034701276, 40.626455162],
            [-74.042372729, 40.624185822],
            [-74.040781415, 40.62108686],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2926",
      },
    },
    {
      type: "Feature",
      id: "sm6cdd4cc2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.042372729, 40.624185822],
            [-74.034701276, 40.626455162],
            [-74.036194148, 40.629362186],
            [-74.043865601, 40.627092944],
            [-74.042372729, 40.624185822],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2925",
      },
    },
    {
      type: "Feature",
      id: "sm1c7dbd00",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043865601, 40.627092944],
            [-74.036194148, 40.629362186],
            [-74.037683592, 40.632262409],
            [-74.045355046, 40.629993266],
            [-74.043865601, 40.627092944],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2924",
      },
    },
    {
      type: "Feature",
      id: "smd624999c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.045355046, 40.629993266],
            [-74.037683592, 40.632262409],
            [-74.03918927, 40.635194115],
            [-74.046860725, 40.632925072],
            [-74.045355046, 40.629993266],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2923",
      },
    },
    {
      type: "Feature",
      id: "smea099752",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046860725, 40.632925072],
            [-74.03918927, 40.635194115],
            [-74.040765838, 40.638263712],
            [-74.048437293, 40.635994773],
            [-74.046860725, 40.632925072],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2922",
      },
    },
    {
      type: "Feature",
      id: "sm7112ae5b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.048437293, 40.635994773],
            [-74.040765838, 40.638263712],
            [-74.042300558, 40.641251695],
            [-74.049972013, 40.638982857],
            [-74.048437293, 40.635994773],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2921",
      },
    },
    {
      type: "Feature",
      id: "sm2c54fc76",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049972013, 40.638982857],
            [-74.042300558, 40.641251695],
            [-74.043836766, 40.64424244],
            [-74.051508221, 40.641973704],
            [-74.049972013, 40.638982857],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2920",
      },
    },
    {
      type: "Feature",
      id: "sme9bf986d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.051508221, 40.641973704],
            [-74.043836766, 40.64424244],
            [-74.045111603, 40.646724237],
            [-74.046570725, 40.647212659],
            [-74.053140324, 40.645151102],
            [-74.051508221, 40.641973704],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2919",
      },
    },
    {
      type: "Feature",
      id: "sm4134a203",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.059550827, 40.639734799],
            [-74.051570503, 40.642094958],
            [-74.053140324, 40.645151102],
            [-74.060475297, 40.642849294],
            [-74.060689873, 40.641970074],
            [-74.059550827, 40.639734799],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2954",
      },
    },
    {
      type: "Feature",
      id: "sm40bbdd9a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.051570503, 40.642094958],
            [-74.059550827, 40.639734799],
            [-74.057968971, 40.636630424],
            [-74.0499777, 40.63899393],
            [-74.051570503, 40.642094958],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2953",
      },
    },
    {
      type: "Feature",
      id: "smd65c166c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.0499777, 40.63899393],
            [-74.057968971, 40.636630424],
            [-74.056499526, 40.633746525],
            [-74.048498087, 40.636113141],
            [-74.0499777, 40.63899393],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2952",
      },
    },
    {
      type: "Feature",
      id: "sma3d3064f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.048498087, 40.636113141],
            [-74.056499526, 40.633746525],
            [-74.05489371, 40.630594845],
            [-74.046881159, 40.632964859],
            [-74.048498087, 40.636113141],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2951",
      },
    },
    {
      type: "Feature",
      id: "sm0082e8ca",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046881159, 40.632964859],
            [-74.05489371, 40.630594845],
            [-74.053419432, 40.627701199],
            [-74.045388304, 40.630058025],
            [-74.046881159, 40.632964859],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2950",
      },
    },
    {
      type: "Feature",
      id: "sm8956242e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.045388304, 40.630058025],
            [-74.053419432, 40.627701199],
            [-74.05187461, 40.624668959],
            [-74.043832781, 40.627029032],
            [-74.045388304, 40.630058025],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2949",
      },
    },
    {
      type: "Feature",
      id: "sm345b7278",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043832781, 40.627029032],
            [-74.05187461, 40.624668959],
            [-74.050295144, 40.621568576],
            [-74.042242374, 40.623931969],
            [-74.043832781, 40.627029032],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2948",
      },
    },
    {
      type: "Feature",
      id: "smbb03e449",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.042242374, 40.623931969],
            [-74.050295144, 40.621568576],
            [-74.048819229, 40.618671325],
            [-74.040756235, 40.621037822],
            [-74.042242374, 40.623931969],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2947",
      },
    },
    {
      type: "Feature",
      id: "sm3c258dce",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040756235, 40.621037822],
            [-74.048819229, 40.618671325],
            [-74.047194336, 40.615481484],
            [-74.039120087, 40.617851397],
            [-74.040756235, 40.621037822],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2946",
      },
    },
    {
      type: "Feature",
      id: "sm5df184b3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.039120087, 40.617851397],
            [-74.047194336, 40.615481484],
            [-74.045701485, 40.61255072],
            [-74.037616895, 40.614923772],
            [-74.039120087, 40.617851397],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2945",
      },
    },
    {
      type: "Feature",
      id: "sm1854ae51",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.037616895, 40.614923772],
            [-74.045701485, 40.61255072],
            [-74.044148195, 40.609501166],
            [-74.036052845, 40.611877485],
            [-74.037616895, 40.614923772],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2944",
      },
    },
    {
      type: "Feature",
      id: "sme0aef4fb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036052845, 40.611877485],
            [-74.044148195, 40.609501166],
            [-74.0426769, 40.606612463],
            [-74.034571358, 40.608991876],
            [-74.036052845, 40.611877485],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2943",
      },
    },
    {
      type: "Feature",
      id: "sm4565a4e6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.034571358, 40.608991876],
            [-74.0426769, 40.606612463],
            [-74.041205605, 40.603723635],
            [-74.033089871, 40.606106143],
            [-74.034571358, 40.608991876],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2942",
      },
    },
    {
      type: "Feature",
      id: "sm4490d431",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.033089871, 40.606106143],
            [-74.041205605, 40.603723635],
            [-74.039585332, 40.600542152],
            [-74.031458375, 40.602928069],
            [-74.033089871, 40.606106143],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2941",
      },
    },
    {
      type: "Feature",
      id: "smb2d39bac",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031458375, 40.602928069],
            [-74.039585332, 40.600542152],
            [-74.038100177, 40.597625846],
            [-74.029962932, 40.600014887],
            [-74.031458375, 40.602928069],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2940",
      },
    },
    {
      type: "Feature",
      id: "smb121a85c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.029962932, 40.600014887],
            [-74.038100177, 40.597625846],
            [-74.036573063, 40.594627015],
            [-74.028425239, 40.597019269],
            [-74.029962932, 40.600014887],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2939",
      },
    },
    {
      type: "Feature",
      id: "sm59beaae9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.028425239, 40.597019269],
            [-74.036573063, 40.594627015],
            [-74.035085185, 40.591705102],
            [-74.026935562, 40.594117062],
            [-74.028425239, 40.597019269],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2938",
      },
    },
    {
      type: "Feature",
      id: "sm4e19b037",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.024349723, 40.591193762],
            [-74.025993299, 40.594395929],
            [-74.035085185, 40.591705102],
            [-74.034296927, 40.590157061],
            [-74.032923636, 40.589798579],
            [-74.024349723, 40.591193762],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2937",
      },
    },
    {
      type: "Feature",
      id: "sme27b5bc1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025993299, 40.594395929],
            [-74.024349723, 40.591193762],
            [-74.017903266, 40.592242737],
            [-74.017688689, 40.593318138],
            [-74.01926411, 40.596387424],
            [-74.025993299, 40.594395929],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2936",
      },
    },
    {
      type: "Feature",
      id: "sme8318012",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.001515536, 40.602520222],
            [-74.009273351, 40.600238674],
            [-74.00774776, 40.597273568],
            [-74.00000984, 40.599568841],
            [-74.001515536, 40.602520222],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2883",
      },
    },
    {
      type: "Feature",
      id: "sm3655c164",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009273351, 40.600238674],
            [-74.001515536, 40.602520222],
            [-74.003062791, 40.605552929],
            [-74.010832106, 40.603268103],
            [-74.009273351, 40.600238674],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2882",
      },
    },
    {
      type: "Feature",
      id: "sm0ac1ca53",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010832106, 40.603268103],
            [-74.003062791, 40.605552929],
            [-74.004629586, 40.608623795],
            [-74.012410546, 40.606335648],
            [-74.010832106, 40.603268103],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2881",
      },
    },
    {
      type: "Feature",
      id: "sma4a4d469",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012410546, 40.606335648],
            [-74.004629586, 40.608623795],
            [-74.006149761, 40.611603152],
            [-74.01394202, 40.609311785],
            [-74.012410546, 40.606335648],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2880",
      },
    },
    {
      type: "Feature",
      id: "sm08fdbb77",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01394202, 40.609311785],
            [-74.006149761, 40.611603152],
            [-74.00769416, 40.61462985],
            [-74.015497898, 40.612335211],
            [-74.01394202, 40.609311785],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2879",
      },
    },
    {
      type: "Feature",
      id: "sm4a491148",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015497898, 40.612335211],
            [-74.00769416, 40.61462985],
            [-74.009191939, 40.617565051],
            [-74.01700681, 40.61526724],
            [-74.015497898, 40.612335211],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2878",
      },
    },
    {
      type: "Feature",
      id: "sm03e31fe0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01700681, 40.61526724],
            [-74.009191939, 40.617565051],
            [-74.010720455, 40.620560356],
            [-74.018546688, 40.618259308],
            [-74.01700681, 40.61526724],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2877",
      },
    },
    {
      type: "Feature",
      id: "sm502b4815",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018546688, 40.618259308],
            [-74.010720455, 40.620560356],
            [-74.012285844, 40.623627778],
            [-74.020114907, 40.621306305],
            [-74.018546688, 40.618259308],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2876",
      },
    },
    {
      type: "Feature",
      id: "sm3830ad75",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020114907, 40.621306305],
            [-74.012285844, 40.623627778],
            [-74.013808434, 40.626611198],
            [-74.021648801, 40.624286477],
            [-74.020114907, 40.621306305],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2875",
      },
    },
    {
      type: "Feature",
      id: "smd93677a0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021648801, 40.624286477],
            [-74.013808434, 40.626611198],
            [-74.015351103, 40.629633826],
            [-74.023202923, 40.627305814],
            [-74.021648801, 40.624286477],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2874",
      },
    },
    {
      type: "Feature",
      id: "sm3e35869a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.023202923, 40.627305814],
            [-74.015351103, 40.629633826],
            [-74.016880007, 40.63262935],
            [-74.024743179, 40.630298077],
            [-74.023202923, 40.627305814],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2873",
      },
    },
    {
      type: "Feature",
      id: "sm428ab8c4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.024743179, 40.630298077],
            [-74.016880007, 40.63262935],
            [-74.018424965, 40.635656189],
            [-74.026308464, 40.633338826],
            [-74.024743179, 40.630298077],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2872",
      },
    },
    {
      type: "Feature",
      id: "sm0e3a6754",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.026308464, 40.633338826],
            [-74.018424965, 40.635656189],
            [-74.019619888, 40.637997157],
            [-74.02107901, 40.638518208],
            [-74.027897769, 40.636426096],
            [-74.026308464, 40.633338826],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2871",
      },
    },
    {
      type: "Feature",
      id: "sm4ade34af",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.034240842, 40.630951504],
            [-74.026292585, 40.633307979],
            [-74.027897769, 40.636426096],
            [-74.034983582, 40.634251978],
            [-74.03536982, 40.633144667],
            [-74.034240842, 40.630951504],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2898",
      },
    },
    {
      type: "Feature",
      id: "sm07123674",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.026292585, 40.633307979],
            [-74.034240842, 40.630951504],
            [-74.032719456, 40.627995929],
            [-74.024771199, 40.630352509],
            [-74.026292585, 40.633307979],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2897",
      },
    },
    {
      type: "Feature",
      id: "sm2523e5d9",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.024771199, 40.630352509],
            [-74.032719456, 40.627995929],
            [-74.031129453, 40.624906913],
            [-74.023181195, 40.627263602],
            [-74.024771199, 40.630352509],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2896",
      },
    },
    {
      type: "Feature",
      id: "sm560e98f8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.023181195, 40.627263602],
            [-74.031129453, 40.624906913],
            [-74.029554888, 40.62184775],
            [-74.02160663, 40.624204547],
            [-74.023181195, 40.627263602],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2895",
      },
    },
    {
      type: "Feature",
      id: "sm5ee8e02c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02160663, 40.624204547],
            [-74.029554888, 40.62184775],
            [-74.028083036, 40.618988016],
            [-74.020134777, 40.621344914],
            [-74.02160663, 40.624204547],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2894",
      },
    },
    {
      type: "Feature",
      id: "sma99f64ca",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020134777, 40.621344914],
            [-74.028083036, 40.618988016],
            [-74.026463441, 40.615841083],
            [-74.018515182, 40.618198093],
            [-74.020134777, 40.621344914],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2893",
      },
    },
    {
      type: "Feature",
      id: "sm1e4e266d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018515182, 40.618198093],
            [-74.026463441, 40.615841083],
            [-74.024939768, 40.612880396],
            [-74.016991509, 40.61523751],
            [-74.018515182, 40.618198093],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2892",
      },
    },
    {
      type: "Feature",
      id: "sm0b9d446e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016991509, 40.61523751],
            [-74.024939768, 40.612880396],
            [-74.023375639, 40.609840962],
            [-74.01542738, 40.612198183],
            [-74.016991509, 40.61523751],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2891",
      },
    },
    {
      type: "Feature",
      id: "smbcfb162f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01542738, 40.612198183],
            [-74.023375639, 40.609840962],
            [-74.021883094, 40.606940501],
            [-74.013934835, 40.609297824],
            [-74.01542738, 40.612198183],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2890",
      },
    },
    {
      type: "Feature",
      id: "smfd4e7357",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013934835, 40.609297824],
            [-74.021883094, 40.606940501],
            [-74.020299881, 40.603863707],
            [-74.012351622, 40.606221139],
            [-74.013934835, 40.609297824],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2889",
      },
    },
    {
      type: "Feature",
      id: "smfdc07842",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.012351622, 40.606221139],
            [-74.020299881, 40.603863707],
            [-74.018727353, 40.600807539],
            [-74.010779095, 40.603165079],
            [-74.012351622, 40.606221139],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2888",
      },
    },
    {
      type: "Feature",
      id: "smd47bba4f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010779095, 40.603165079],
            [-74.018727353, 40.600807539],
            [-74.017217797, 40.597873623],
            [-74.009269539, 40.600231266],
            [-74.010779095, 40.603165079],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2887",
      },
    },
    {
      type: "Feature",
      id: "sm6bb91dae",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009269539, 40.600231266],
            [-74.017217797, 40.597873623],
            [-74.015696018, 40.594915821],
            [-74.00774776, 40.597273568],
            [-74.009269539, 40.600231266],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2886",
      },
    },
    {
      type: "Feature",
      id: "sm403c253d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004997788, 40.594352652],
            [-74.006665716, 40.597594536],
            [-74.015696018, 40.594915821],
            [-74.014899192, 40.593367019],
            [-74.013783393, 40.592894497],
            [-74.004997788, 40.594352652],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2885",
      },
    },
    {
      type: "Feature",
      id: "sm105ec9c1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006665716, 40.597594536],
            [-74.004997788, 40.594352652],
            [-73.998763025, 40.595387422],
            [-73.998333872, 40.596283548],
            [-74.00000984, 40.599568841],
            [-74.006665716, 40.597594536],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2884",
      },
    },
    {
      type: "Feature",
      id: "sm599c5906",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.98955977, 40.60303577],
            [-73.997792521, 40.600578343],
            [-73.995737491, 40.596609409],
            [-73.994385649, 40.596169509],
            [-73.989493304, 40.596951573],
            [-73.988634997, 40.597863972],
            [-73.98955977, 40.60303577],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2846",
      },
    },
    {
      type: "Feature",
      id: "sm68b8eb4a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.999391861, 40.629354441],
            [-73.996073846, 40.622948915],
            [-73.993270738, 40.623785356],
            [-73.994385653, 40.630018055],
            [-73.995415622, 40.630539168],
            [-73.999391861, 40.629354441],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2861",
      },
    },
    {
      type: "Feature",
      id: "sm17459c87",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.996073846, 40.622948915],
            [-73.999391861, 40.629354441],
            [-74.003160399, 40.62823158],
            [-73.999841679, 40.621824585],
            [-73.996073846, 40.622948915],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2860",
      },
    },
    {
      type: "Feature",
      id: "sm076b9725",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.999841679, 40.621824585],
            [-74.003160399, 40.62823158],
            [-74.006931485, 40.627107941],
            [-74.00361206, 40.620699476],
            [-73.999841679, 40.621824585],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2859",
      },
    },
    {
      type: "Feature",
      id: "smcd2f9124",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00361206, 40.620699476],
            [-74.006931485, 40.627107941],
            [-74.009899554, 40.626223557],
            [-74.010500369, 40.625116113],
            [-74.007596808, 40.619510378],
            [-74.00361206, 40.620699476],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2858",
      },
    },
    {
      type: "Feature",
      id: "sm7ac3c20f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.998973039, 40.61818601],
            [-74.000721616, 40.621562007],
            [-74.007596808, 40.619510378],
            [-74.005848231, 40.616134278],
            [-73.998973039, 40.61818601],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2856",
      },
    },
    {
      type: "Feature",
      id: "sm7e9a2c92",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.000721616, 40.621562007],
            [-73.998973039, 40.61818601],
            [-73.992608894, 40.620085177],
            [-73.993270738, 40.623785356],
            [-74.000721616, 40.621562007],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2857",
      },
    },
    {
      type: "Feature",
      id: "sm746d50e5",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.99745632, 40.614284566],
            [-73.999409482, 40.618055767],
            [-74.005848231, 40.616134278],
            [-74.00389507, 40.612362969],
            [-73.99745632, 40.614284566],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2854",
      },
    },
    {
      type: "Feature",
      id: "sma410a6ab",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.999409482, 40.618055767],
            [-73.99745632, 40.614284566],
            [-73.991869613, 40.615951833],
            [-73.992608894, 40.620085177],
            [-73.999409482, 40.618055767],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2855",
      },
    },
    {
      type: "Feature",
      id: "smeda32749",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.996137941, 40.60985366],
            [-73.998301934, 40.614032202],
            [-74.00389507, 40.612362969],
            [-74.001731077, 40.608184322],
            [-73.996137941, 40.60985366],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2852",
      },
    },
    {
      type: "Feature",
      id: "sm46f8828f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.998301934, 40.614032202],
            [-73.996137941, 40.60985366],
            [-73.991050532, 40.611372021],
            [-73.991869613, 40.615951833],
            [-73.998301934, 40.614032202],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2853",
      },
    },
    {
      type: "Feature",
      id: "sm29ef4dca",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.994236725, 40.604758753],
            [-73.99677642, 40.6096631],
            [-74.001731077, 40.608184322],
            [-73.999191382, 40.603279866],
            [-73.994236725, 40.604758753],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2848",
      },
    },
    {
      type: "Feature",
      id: "sm7bc7fa30",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.99677642, 40.6096631],
            [-73.994236725, 40.604758753],
            [-73.990089246, 40.605996685],
            [-73.991050532, 40.611372021],
            [-73.99677642, 40.6096631],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2851",
      },
    },
    {
      type: "Feature",
      id: "sm6832edf4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.990089246, 40.605996685],
            [-73.999191382, 40.603279866],
            [-73.997792521, 40.600578343],
            [-73.98955977, 40.60303577],
            [-73.990089246, 40.605996685],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2847",
      },
    },
    {
      type: "Feature",
      id: "smc13eabdc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.995821868, 40.637872024],
            [-74.001588716, 40.636088514],
            [-73.999111468, 40.631475693],
            [-73.995716029, 40.632525877],
            [-73.995072298, 40.63343779],
            [-73.995821868, 40.637872024],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2862",
      },
    },
    {
      type: "Feature",
      id: "sm8b111be0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.003599812, 40.639833089],
            [-73.996523346, 40.642021494],
            [-73.996960573, 40.644607708],
            [-73.998119287, 40.645193832],
            [-74.005178864, 40.642979544],
            [-74.005274889, 40.642951851],
            [-74.003599812, 40.639833089],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2870",
      },
    },
    {
      type: "Feature",
      id: "sm5136ab13",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.996523346, 40.642021494],
            [-74.003599812, 40.639833089],
            [-74.001588716, 40.636088514],
            [-73.995821868, 40.637872024],
            [-73.996523346, 40.642021494],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2869",
      },
    },
    {
      type: "Feature",
      id: "smced3f512",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009216881, 40.641814996],
            [-74.006317284, 40.63602586],
            [-74.002233389, 40.63728889],
            [-74.005274889, 40.642951851],
            [-74.009216881, 40.641814996],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2868",
      },
    },
    {
      type: "Feature",
      id: "smf059218f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010449518, 40.634747856],
            [-74.01338682, 40.640612381],
            [-74.016808922, 40.639625427],
            [-74.017366822, 40.638583337],
            [-74.014636885, 40.633452776],
            [-74.010449518, 40.634747856],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2866",
      },
    },
    {
      type: "Feature",
      id: "sm23a3e26b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.01338682, 40.640612381],
            [-74.010449518, 40.634747856],
            [-74.006317284, 40.63602586],
            [-74.009216881, 40.641814996],
            [-74.01338682, 40.640612381],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2867",
      },
    },
    {
      type: "Feature",
      id: "sme4f1de88",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007404929, 40.62900026],
            [-74.010356945, 40.634776487],
            [-74.014636885, 40.633452776],
            [-74.01187366, 40.628259252],
            [-74.010586199, 40.628063828],
            [-74.007404929, 40.62900026],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2865",
      },
    },
    {
      type: "Feature",
      id: "sm014e8292",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.010356945, 40.634776487],
            [-74.007404929, 40.62900026],
            [-74.003389714, 40.630182152],
            [-74.006368221, 40.636010107],
            [-74.010356945, 40.634776487],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2864",
      },
    },
    {
      type: "Feature",
      id: "sm8b306c26",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.006368221, 40.636010107],
            [-74.003389714, 40.630182152],
            [-74.001402316, 40.630767142],
            [-73.999111468, 40.631475693],
            [-74.002233389, 40.63728889],
            [-74.006368221, 40.636010107],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2863",
      },
    },
    {
      type: "Feature",
      id: "sm7cd005be",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.998559028, 40.652681054],
            [-74.004004205, 40.651122966],
            [-74.001486597, 40.646058323],
            [-73.998380844, 40.646947077],
            [-73.998290949, 40.647114971],
            [-73.997690134, 40.648091806],
            [-73.998559028, 40.652681054],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2908",
      },
    },
    {
      type: "Feature",
      id: "sm90e91e6c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004004205, 40.651122966],
            [-73.998559028, 40.652681054],
            [-73.999921733, 40.659877836],
            [-74.000908785, 40.660398717],
            [-74.007623121, 40.658402424],
            [-74.004004205, 40.651122966],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2909",
      },
    },
    {
      type: "Feature",
      id: "sm53616de3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.011585827, 40.657224212],
            [-74.008534116, 40.651085632],
            [-74.004552076, 40.65222506],
            [-74.007623121, 40.658402424],
            [-74.011585827, 40.657224212],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2918",
      },
    },
    {
      type: "Feature",
      id: "sm78bf0264",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.035848567, 40.643269299],
            [-74.038810732, 40.649228461],
            [-74.042300634, 40.648205769],
            [-74.042665415, 40.647245217],
            [-74.039954188, 40.642094351],
            [-74.035848567, 40.643269299],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2917",
      },
    },
    {
      type: "Feature",
      id: "sm44b52b6b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038810732, 40.649228461],
            [-74.035848567, 40.643269299],
            [-74.031957052, 40.644382955],
            [-74.034930849, 40.650365416],
            [-74.038810732, 40.649228461],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2916",
      },
    },
    {
      type: "Feature",
      id: "sm2c5ab0e6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.034930849, 40.650365416],
            [-74.031957052, 40.644382955],
            [-74.028103756, 40.645485656],
            [-74.03108907, 40.651491186],
            [-74.034930849, 40.650365416],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2915",
      },
    },
    {
      type: "Feature",
      id: "sm897f6ec7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.03108907, 40.651491186],
            [-74.028103756, 40.645485656],
            [-74.024155561, 40.646615495],
            [-74.027152676, 40.652644662],
            [-74.03108907, 40.651491186],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2914",
      },
    },
    {
      type: "Feature",
      id: "sm00e1bd50",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.027152676, 40.652644662],
            [-74.024155561, 40.646615495],
            [-74.020404451, 40.647688917],
            [-74.023412778, 40.65374054],
            [-74.027152676, 40.652644662],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2913",
      },
    },
    {
      type: "Feature",
      id: "sm43cef9de",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.023412778, 40.65374054],
            [-74.020404451, 40.647688917],
            [-74.016278927, 40.648869462],
            [-74.019299585, 40.654945782],
            [-74.023412778, 40.65374054],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2912",
      },
    },
    {
      type: "Feature",
      id: "sm640c1d47",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.019299585, 40.654945782],
            [-74.016278927, 40.648869462],
            [-74.012359072, 40.649991134],
            [-74.015392212, 40.656092459],
            [-74.015800409, 40.655971088],
            [-74.019299585, 40.654945782],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2911",
      },
    },
    {
      type: "Feature",
      id: "sm76a6f527",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015392212, 40.656092459],
            [-74.012359072, 40.649991134],
            [-74.008534116, 40.651085632],
            [-74.011585827, 40.657224212],
            [-74.015392212, 40.656092459],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2910",
      },
    },
    {
      type: "Feature",
      id: "sm0dc7bd01",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.032787462, 40.637100483],
            [-74.035852941, 40.643268047],
            [-74.039954188, 40.642094351],
            [-74.037086422, 40.636645655],
            [-74.035798962, 40.636238573],
            [-74.032787462, 40.637100483],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2899",
      },
    },
    {
      type: "Feature",
      id: "smb0045362",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.008616223, 40.651062137],
            [-74.005550745, 40.644895293],
            [-74.001486597, 40.646058323],
            [-74.004552076, 40.65222506],
            [-74.008616223, 40.651062137],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2907",
      },
    },
    {
      type: "Feature",
      id: "sm0fdbb3bd",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.005550745, 40.644895293],
            [-74.008616223, 40.651062137],
            [-74.012487981, 40.649954246],
            [-74.009422503, 40.643787299],
            [-74.005550745, 40.644895293],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2906",
      },
    },
    {
      type: "Feature",
      id: "sm20443df7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.009422503, 40.643787299],
            [-74.012487981, 40.649954246],
            [-74.016361034, 40.648845966],
            [-74.013295556, 40.642678917],
            [-74.009422503, 40.643787299],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2905",
      },
    },
    {
      type: "Feature",
      id: "smc0a8a6a1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013295556, 40.642678917],
            [-74.016361034, 40.648845966],
            [-74.020252549, 40.647732384],
            [-74.017187071, 40.641565232],
            [-74.013295556, 40.642678917],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2904",
      },
    },
    {
      type: "Feature",
      id: "smb493e1f0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017187071, 40.641565232],
            [-74.020252549, 40.647732384],
            [-74.024097262, 40.646632177],
            [-74.021031784, 40.640464923],
            [-74.017187071, 40.641565232],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2903",
      },
    },
    {
      type: "Feature",
      id: "smf455936a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.021031784, 40.640464923],
            [-74.024097262, 40.646632177],
            [-74.02809226, 40.645488945],
            [-74.025026781, 40.639321586],
            [-74.021031784, 40.640464923],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2902",
      },
    },
    {
      type: "Feature",
      id: "sm6600020c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025026781, 40.639321586],
            [-74.02809226, 40.645488945],
            [-74.032122884, 40.644335498],
            [-74.029057406, 40.638168032],
            [-74.025026781, 40.639321586],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2901",
      },
    },
    {
      type: "Feature",
      id: "sm2c945632",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.029057406, 40.638168032],
            [-74.032122884, 40.644335498],
            [-74.035852941, 40.643268047],
            [-74.032787462, 40.637100483],
            [-74.029057406, 40.638168032],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2900",
      },
    },
    {
      type: "Feature",
      id: "sm3f5e66d3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.001771549, 40.66996404],
            [-74.00986307, 40.667591995],
            [-74.006455448, 40.660904131],
            [-74.001295028, 40.662417079],
            [-74.000522552, 40.663654118],
            [-74.001771549, 40.66996404],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3012",
      },
    },
    {
      type: "Feature",
      id: "sm49cf7c44",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.00986307, 40.667591995],
            [-74.001771549, 40.66996404],
            [-74.002797061, 40.675144471],
            [-74.003784114, 40.675600138],
            [-74.012511825, 40.672790029],
            [-74.00986307, 40.667591995],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3011",
      },
    },
    {
      type: "Feature",
      id: "sma2a07905",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020468442, 40.670451824],
            [-74.017434826, 40.664498279],
            [-74.009475634, 40.66683164],
            [-74.012511825, 40.672790029],
            [-74.012882171, 40.672670784],
            [-74.020468442, 40.670451824],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3013",
      },
    },
    {
      type: "Feature",
      id: "sm66cd8762",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.057024793, 40.65289065],
            [-74.060069696, 40.658867386],
            [-74.067298827, 40.656752452],
            [-74.067899642, 40.6558083],
            [-74.065163023, 40.650504302],
            [-74.057024793, 40.65289065],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3019",
      },
    },
    {
      type: "Feature",
      id: "sm86d5f4bf",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.060069696, 40.658867386],
            [-74.057024793, 40.65289065],
            [-74.049151326, 40.655199282],
            [-74.052193985, 40.661171405],
            [-74.060069696, 40.658867386],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3018",
      },
    },
    {
      type: "Feature",
      id: "sme0b22122",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.052193985, 40.661171405],
            [-74.049151326, 40.655199282],
            [-74.041367663, 40.657481503],
            [-74.044408103, 40.663449066],
            [-74.052193985, 40.661171405],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3017",
      },
    },
    {
      type: "Feature",
      id: "smce13e480",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.044408103, 40.663449066],
            [-74.041367663, 40.657481503],
            [-74.033534968, 40.659778022],
            [-74.036573174, 40.665740997],
            [-74.044408103, 40.663449066],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3016",
      },
    },
    {
      type: "Feature",
      id: "smfa51fa44",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036573174, 40.665740997],
            [-74.033534968, 40.659778022],
            [-74.025476421, 40.662140677],
            [-74.02851233, 40.668098932],
            [-74.036573174, 40.665740997],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3015",
      },
    },
    {
      type: "Feature",
      id: "sm65753ede",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02851233, 40.668098932],
            [-74.025476421, 40.662140677],
            [-74.017434826, 40.664498279],
            [-74.020468442, 40.670451824],
            [-74.02851233, 40.668098932],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3014",
      },
    },
    {
      type: "Feature",
      id: "sm6f30b444",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05412778, 40.646925783],
            [-74.057147966, 40.652854533],
            [-74.065163023, 40.650504302],
            [-74.062406477, 40.645161255],
            [-74.061033186, 40.644900756],
            [-74.05412778, 40.646925783],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3004",
      },
    },
    {
      type: "Feature",
      id: "sma6ef5e03",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.017374743, 40.664515893],
            [-74.014354557, 40.658588179],
            [-74.006455448, 40.660904131],
            [-74.009475634, 40.66683164],
            [-74.017374743, 40.664515893],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3010",
      },
    },
    {
      type: "Feature",
      id: "sm0754f379",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.014354557, 40.658588179],
            [-74.017374743, 40.664515893],
            [-74.025426423, 40.662155335],
            [-74.022406237, 40.656227411],
            [-74.014354557, 40.658588179],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3009",
      },
    },
    {
      type: "Feature",
      id: "sm2a9383c3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022406237, 40.656227411],
            [-74.025426423, 40.662155335],
            [-74.033267809, 40.65985635],
            [-74.030247624, 40.653928222],
            [-74.022406237, 40.656227411],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3008",
      },
    },
    {
      type: "Feature",
      id: "sme8b1851c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.030247624, 40.653928222],
            [-74.033267809, 40.65985635],
            [-74.041360261, 40.657483673],
            [-74.038340075, 40.651555334],
            [-74.030247624, 40.653928222],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3007",
      },
    },
    {
      type: "Feature",
      id: "sm30892861",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.038340075, 40.651555334],
            [-74.041360261, 40.657483673],
            [-74.049211733, 40.65518157],
            [-74.046191547, 40.649253026],
            [-74.038340075, 40.651555334],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3006",
      },
    },
    {
      type: "Feature",
      id: "sm43b9d820",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046191547, 40.649253026],
            [-74.049211733, 40.65518157],
            [-74.057147966, 40.652854533],
            [-74.05412778, 40.646925783],
            [-74.046191547, 40.649253026],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3005",
      },
    },
    {
      type: "Feature",
      id: "sm07f7916f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.004862497, 40.687703774],
            [-74.016524454, 40.684266745],
            [-74.011874346, 40.675193408],
            [-74.004642425, 40.677325122],
            [-74.003354964, 40.67859443],
            [-74.004862497, 40.687703774],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3025",
      },
    },
    {
      type: "Feature",
      id: "smcfca2c25",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016524454, 40.684266745],
            [-74.004862497, 40.687703774],
            [-74.006058626, 40.694930556],
            [-74.007346086, 40.695451163],
            [-74.020268277, 40.691570832],
            [-74.016524454, 40.684266745],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3026",
      },
    },
    {
      type: "Feature",
      id: "smbb8ef3d3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.03176699, 40.688346962],
            [-74.027553406, 40.680125932],
            [-74.016128101, 40.683493426],
            [-74.020268277, 40.691570832],
            [-74.020617033, 40.691466103],
            [-74.020521102, 40.691611578],
            [-74.03176699, 40.688346962],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3027",
      },
    },
    {
      type: "Feature",
      id: "sme3d6ed61",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.061843207, 40.670018336],
            [-74.066124256, 40.678372257],
            [-74.076568541, 40.675339745],
            [-74.077255187, 40.674233117],
            [-74.073397366, 40.666612175],
            [-74.061843207, 40.670018336],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3031",
      },
    },
    {
      type: "Feature",
      id: "sm5d612779",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.066124256, 40.678372257],
            [-74.061843207, 40.670018336],
            [-74.050584545, 40.673337218],
            [-74.054843443, 40.681647501],
            [-74.066124256, 40.678372257],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3030",
      },
    },
    {
      type: "Feature",
      id: "sm84fa75b0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.054843443, 40.681647501],
            [-74.050584545, 40.673337218],
            [-74.038936446, 40.676770726],
            [-74.043172426, 40.685035867],
            [-74.054843443, 40.681647501],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3029",
      },
    },
    {
      type: "Feature",
      id: "sma5db2fe1",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043172426, 40.685035867],
            [-74.038936446, 40.676770726],
            [-74.027553406, 40.680125932],
            [-74.03176699, 40.688346962],
            [-74.043172426, 40.685035867],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3028",
      },
    },
    {
      type: "Feature",
      id: "smb93b938e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.057703566, 40.661682997],
            [-74.061957321, 40.669984697],
            [-74.073397366, 40.666612175],
            [-74.06965917, 40.659226718],
            [-74.068242965, 40.658575605],
            [-74.057703566, 40.661682997],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3020",
      },
    },
    {
      type: "Feature",
      id: "sm8ee028a8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.02767537, 40.680089984],
            [-74.023421614, 40.671789542],
            [-74.011874346, 40.675193408],
            [-74.016128101, 40.683493426],
            [-74.02767537, 40.680089984],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3024",
      },
    },
    {
      type: "Feature",
      id: "smd6d376a2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.023421614, 40.671789542],
            [-74.02767537, 40.680089984],
            [-74.038826559, 40.676803117],
            [-74.034572803, 40.668502266],
            [-74.023421614, 40.671789542],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3023",
      },
    },
    {
      type: "Feature",
      id: "sm6e39dbb7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.034572803, 40.668502266],
            [-74.038826559, 40.676803117],
            [-74.050491563, 40.673364628],
            [-74.046237808, 40.665063348],
            [-74.034572803, 40.668502266],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3022",
      },
    },
    {
      type: "Feature",
      id: "sma6174425",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046237808, 40.665063348],
            [-74.050491563, 40.673364628],
            [-74.061957321, 40.669984697],
            [-74.057703566, 40.661682997],
            [-74.046237808, 40.665063348],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3021",
      },
    },
    {
      type: "Feature",
      id: "smecce8162",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.007801966, 40.704472037],
            [-74.024706426, 40.699544833],
            [-74.021582073, 40.693383664],
            [-74.007903991, 40.697370861],
            [-74.006616531, 40.698802468],
            [-74.007801966, 40.704472037],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3037",
      },
    },
    {
      type: "Feature",
      id: "sm34d24074",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.020388903, 40.712950803],
            [-74.015021332, 40.702367827],
            [-74.007801966, 40.704472037],
            [-74.010092669, 40.715426389],
            [-74.011294298, 40.715686612],
            [-74.020388903, 40.712950803],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3038",
      },
    },
    {
      type: "Feature",
      id: "smafb1fc45",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.015021332, 40.702367827],
            [-74.020388903, 40.712950803],
            [-74.030033943, 40.710049291],
            [-74.024706426, 40.699544833],
            [-74.015021332, 40.702367827],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3039",
      },
    },
    {
      type: "Feature",
      id: "smffb63d66",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040975908, 40.706757473],
            [-74.036763471, 40.698451386],
            [-74.025776068, 40.701654018],
            [-74.030033943, 40.710049291],
            [-74.040975908, 40.706757473],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3040",
      },
    },
    {
      type: "Feature",
      id: "sme75e26e3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.071124749, 40.688434694],
            [-74.075327651, 40.696723226],
            [-74.085924086, 40.69362901],
            [-74.086610732, 40.692522685],
            [-74.082800619, 40.685030706],
            [-74.071124749, 40.688434694],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3044",
      },
    },
    {
      type: "Feature",
      id: "sm7536e2f0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.075327651, 40.696723226],
            [-74.071124749, 40.688434694],
            [-74.060000783, 40.691677618],
            [-74.064206151, 40.69997061],
            [-74.075327651, 40.696723226],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3043",
      },
    },
    {
      type: "Feature",
      id: "sm1b60413c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.064206151, 40.69997061],
            [-74.060000783, 40.691677618],
            [-74.048497265, 40.695031025],
            [-74.052705183, 40.703328628],
            [-74.064206151, 40.69997061],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3042",
      },
    },
    {
      type: "Feature",
      id: "sme8094a80",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.052705183, 40.703328628],
            [-74.048497265, 40.695031025],
            [-74.036763471, 40.698451386],
            [-74.040975908, 40.706757473],
            [-74.04146379, 40.706610693],
            [-74.052705183, 40.703328628],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3041",
      },
    },
    {
      type: "Feature",
      id: "sm563db1ef",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.067033314, 40.680132795],
            [-74.071227309, 40.688404794],
            [-74.082800619, 40.685030706],
            [-74.079014716, 40.677585497],
            [-74.077555594, 40.677064751],
            [-74.067033314, 40.680132795],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3032",
      },
    },
    {
      type: "Feature",
      id: "smdcbcf44c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.036865478, 40.698421652],
            [-74.032671484, 40.690150897],
            [-74.021582073, 40.693383664],
            [-74.025776068, 40.701654018],
            [-74.036865478, 40.698421652],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3036",
      },
    },
    {
      type: "Feature",
      id: "smb29f1de2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.032671484, 40.690150897],
            [-74.036865478, 40.698421652],
            [-74.048622216, 40.694994601],
            [-74.044428222, 40.68672342],
            [-74.032671484, 40.690150897],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3035",
      },
    },
    {
      type: "Feature",
      id: "smd3be09f8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.044428222, 40.68672342],
            [-74.048622216, 40.694994601],
            [-74.060011012, 40.691674636],
            [-74.055817017, 40.683403043],
            [-74.044428222, 40.68672342],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3034",
      },
    },
    {
      type: "Feature",
      id: "sm130ecc0d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055817017, 40.683403043],
            [-74.060011012, 40.691674636],
            [-74.071227309, 40.688404794],
            [-74.067033314, 40.680132795],
            [-74.055817017, 40.683403043],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3033",
      },
    },
    {
      type: "Feature",
      id: "sm27bef16e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.016316385, 40.716347479],
            [-74.018784583, 40.721117049],
            [-74.028779576, 40.718146947],
            [-74.026615079, 40.7139626],
            [-74.025542196, 40.713604782],
            [-74.016316385, 40.716347479],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3045",
      },
    },
    {
      type: "Feature",
      id: "smef713556",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018784583, 40.721117049],
            [-74.016316385, 40.716347479],
            [-74.011208471, 40.717865938],
            [-74.010607656, 40.718776684],
            [-74.011442953, 40.723298596],
            [-74.018784583, 40.721117049],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3046",
      },
    },
    {
      type: "Feature",
      id: "sm4717a5f0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.018234866, 40.760055461],
            [-74.034571214, 40.755122783],
            [-74.031330334, 40.748963758],
            [-74.016973034, 40.753228142],
            [-74.018234866, 40.760055461],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3053",
      },
    },
    {
      type: "Feature",
      id: "sm3d8151a8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.031024518, 40.768374159],
            [-74.025493106, 40.757863917],
            [-74.018234866, 40.760055461],
            [-74.020220692, 40.770798627],
            [-74.021593983, 40.771221138],
            [-74.031024518, 40.768374159],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3054",
      },
    },
    {
      type: "Feature",
      id: "sm97108792",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.025493106, 40.757863917],
            [-74.031024518, 40.768374159],
            [-74.040102625, 40.765633458],
            [-74.034571214, 40.755122783],
            [-74.025493106, 40.757863917],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3055",
      },
    },
    {
      type: "Feature",
      id: "sme188c477",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.047268968, 40.753879419],
            [-74.035747633, 40.757358331],
            [-74.040102625, 40.765633458],
            [-74.04021924, 40.765598251],
            [-74.050733499, 40.762445334],
            [-74.051248483, 40.761567692],
            [-74.047268968, 40.753879419],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3056",
      },
    },
    {
      type: "Feature",
      id: "sm5470a478",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.035747633, 40.757358331],
            [-74.047268968, 40.753879419],
            [-74.04294012, 40.745515237],
            [-74.031330334, 40.748963758],
            [-74.035747633, 40.757358331],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3052",
      },
    },
    {
      type: "Feature",
      id: "sm15dd3803",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.026306384, 40.741579739],
            [-74.03028794, 40.749273378],
            [-74.04294012, 40.745515237],
            [-74.038958564, 40.737821163],
            [-74.026306384, 40.741579739],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3051",
      },
    },
    {
      type: "Feature",
      id: "sme8ea14fe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.03028794, 40.749273378],
            [-74.026306384, 40.741579739],
            [-74.015418127, 40.744814137],
            [-74.016973034, 40.753228142],
            [-74.03028794, 40.749273378],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3050",
      },
    },
    {
      type: "Feature",
      id: "smf8058992",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.023393235, 40.732445247],
            [-74.027878223, 40.741112805],
            [-74.038958564, 40.737821163],
            [-74.034473575, 40.729153176],
            [-74.023393235, 40.732445247],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3048",
      },
    },
    {
      type: "Feature",
      id: "sm4c785ea3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.027878223, 40.741112805],
            [-74.023393235, 40.732445247],
            [-74.013666616, 40.73533498],
            [-74.015418127, 40.744814137],
            [-74.027878223, 40.741112805],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3049",
      },
    },
    {
      type: "Feature",
      id: "sm266f1526",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.013666616, 40.73533498],
            [-74.034473575, 40.729153176],
            [-74.028779576, 40.718146947],
            [-74.011442953, 40.723298596],
            [-74.013666616, 40.73533498],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3047",
      },
    },
    {
      type: "Feature",
      id: "sm6ff40cd4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.022394534, 40.783527823],
            [-74.034029318, 40.780047851],
            [-74.02917159, 40.770735015],
            [-74.021679812, 40.772976146],
            [-74.020649843, 40.774243631],
            [-74.022394534, 40.783527823],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3059",
      },
    },
    {
      type: "Feature",
      id: "sm12006731",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.034029318, 40.780047851],
            [-74.022394534, 40.783527823],
            [-74.023782666, 40.790913694],
            [-74.02485555, 40.791368568],
            [-74.037644322, 40.787437049],
            [-74.037853555, 40.787378443],
            [-74.034029318, 40.780047851],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3060",
      },
    },
    {
      type: "Feature",
      id: "sm76a07ffc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049429649, 40.784135921],
            [-74.045111832, 40.775858733],
            [-74.03363488, 40.779291715],
            [-74.037853555, 40.787378443],
            [-74.049429649, 40.784135921],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3061",
      },
    },
    {
      type: "Feature",
      id: "sm51563384",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.045111832, 40.775858733],
            [-74.049429649, 40.784135921],
            [-74.059917382, 40.781198117],
            [-74.060260705, 40.779833275],
            [-74.056591932, 40.772424631],
            [-74.045111832, 40.775858733],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3062",
      },
    },
    {
      type: "Feature",
      id: "sm2b226430",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040528287, 40.767337567],
            [-74.044991578, 40.775894704],
            [-74.056591932, 40.772424631],
            [-74.052793435, 40.764753155],
            [-74.05090516, 40.76423309],
            [-74.040528287, 40.767337567],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3057",
      },
    },
    {
      type: "Feature",
      id: "smb6ca3ddc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.044991578, 40.775894704],
            [-74.040528287, 40.767337567],
            [-74.02917159, 40.770735015],
            [-74.03363488, 40.779291715],
            [-74.044991578, 40.775894704],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3058",
      },
    },
    {
      type: "Feature",
      id: "sm3432cbcb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.080198817, 40.755727692],
            [-74.067364854, 40.75954492],
            [-74.076089386, 40.77637272],
            [-74.087511972, 40.772976151],
            [-74.088370279, 40.771546139],
            [-74.080198817, 40.755727692],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3070",
      },
    },
    {
      type: "Feature",
      id: "sm19d44b3c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.067364854, 40.75954492],
            [-74.080198817, 40.755727692],
            [-74.071441471, 40.738770901],
            [-74.058580369, 40.742597177],
            [-74.067364854, 40.75954492],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3069",
      },
    },
    {
      type: "Feature",
      id: "sm0799c408",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.058580369, 40.742597177],
            [-74.071441471, 40.738770901],
            [-74.062740209, 40.721918422],
            [-74.049852141, 40.725753691],
            [-74.058580369, 40.742597177],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3068",
      },
    },
    {
      type: "Feature",
      id: "sm4b124598",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049852141, 40.725753691],
            [-74.062740209, 40.721918422],
            [-74.054552991, 40.706057641],
            [-74.052922208, 40.705406985],
            [-74.041099633, 40.708859069],
            [-74.049852141, 40.725753691],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3067",
      },
    },
    {
      type: "Feature",
      id: "smf7a6cc5c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.037103042, 40.729376487],
            [-74.049775417, 40.725605612],
            [-74.041099633, 40.708859069],
            [-74.029747922, 40.712173496],
            [-74.029061277, 40.713669843],
            [-74.037103042, 40.729376487],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3066",
      },
    },
    {
      type: "Feature",
      id: "sm4396137c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049775417, 40.725605612],
            [-74.037103042, 40.729376487],
            [-74.045826837, 40.746411038],
            [-74.058589263, 40.742614337],
            [-74.049775417, 40.725605612],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3065",
      },
    },
    {
      type: "Feature",
      id: "sm919bdfc8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.058589263, 40.742614337],
            [-74.045826837, 40.746411038],
            [-74.054542147, 40.763424664],
            [-74.067394537, 40.759602178],
            [-74.058589263, 40.742614337],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3064",
      },
    },
    {
      type: "Feature",
      id: "smcf5cbd14",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.067394537, 40.759602178],
            [-74.054542147, 40.763424664],
            [-74.062749819, 40.779443322],
            [-74.06412311, 40.779930772],
            [-74.076089386, 40.77637272],
            [-74.067394537, 40.759602178],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3063",
      },
    },
    {
      type: "Feature",
      id: "smabd96017",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.115560621, 40.748868552],
            [-74.099332382, 40.753542055],
            [-74.106349261, 40.767522984],
            [-74.121500931, 40.763160446],
            [-74.122187577, 40.761795234],
            [-74.115560621, 40.748868552],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3080",
      },
    },
    {
      type: "Feature",
      id: "sm000a48e0",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.099332382, 40.753542055],
            [-74.115560621, 40.748868552],
            [-74.108659283, 40.735403982],
            [-74.092558156, 40.740041818],
            [-74.099332382, 40.753542055],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3079",
      },
    },
    {
      type: "Feature",
      id: "sme6d854b3",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.092558156, 40.740041818],
            [-74.108659283, 40.735403982],
            [-74.101803529, 40.722025649],
            [-74.085828676, 40.726628039],
            [-74.092558156, 40.740041818],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3078",
      },
    },
    {
      type: "Feature",
      id: "smee0e6fde",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.085828676, 40.726628039],
            [-74.101803529, 40.722025649],
            [-74.094947775, 40.708644626],
            [-74.079099196, 40.713211556],
            [-74.085828676, 40.726628039],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3077",
      },
    },
    {
      type: "Feature",
      id: "sm700e398f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.079099196, 40.713211556],
            [-74.094947775, 40.708644626],
            [-74.088456114, 40.695971758],
            [-74.086911161, 40.695255927],
            [-74.072275105, 40.699603688],
            [-74.079099196, 40.713211556],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3076",
      },
    },
    {
      type: "Feature",
      id: "smcba940ec",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.063083778, 40.717994084],
            [-74.07917275, 40.713358214],
            [-74.072275105, 40.699603688],
            [-74.057557066, 40.703975517],
            [-74.05687042, 40.705732312],
            [-74.063083778, 40.717994084],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3075",
      },
    },
    {
      type: "Feature",
      id: "sm83adbefe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.07917275, 40.713358214],
            [-74.063083778, 40.717994084],
            [-74.069904138, 40.731451146],
            [-74.085931914, 40.726833842],
            [-74.07917275, 40.713358214],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3074",
      },
    },
    {
      type: "Feature",
      id: "sma8d4692a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.085931914, 40.726833842],
            [-74.069904138, 40.731451146],
            [-74.07670737, 40.744871702],
            [-74.092674104, 40.740272912],
            [-74.085931914, 40.726833842],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3073",
      },
    },
    {
      type: "Feature",
      id: "sm3b4469bb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.092674104, 40.740272912],
            [-74.07670737, 40.744871702],
            [-74.083570508, 40.75840769],
            [-74.099475663, 40.753827569],
            [-74.092674104, 40.740272912],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3072",
      },
    },
    {
      type: "Feature",
      id: "smc1b318f6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.099475663, 40.753827569],
            [-74.083570508, 40.75840769],
            [-74.090101302, 40.771285645],
            [-74.091877329, 40.771689542],
            [-74.106349261, 40.767522984],
            [-74.099475663, 40.753827569],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3071",
      },
    },
    {
      type: "Feature",
      id: "smc1d5bf6a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.141982792, 40.775741271],
            [-74.133129244, 40.778387574],
            [-74.13568626, 40.783500372],
            [-74.137250854, 40.783992711],
            [-74.143473579, 40.782302974],
            [-74.14449619, 40.78056317],
            [-74.141982792, 40.775741271],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3003",
      },
    },
    {
      type: "Feature",
      id: "sm7212cac4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.133129244, 40.778387574],
            [-74.141982792, 40.775741271],
            [-74.138917442, 40.769859992],
            [-74.130172084, 40.772474189],
            [-74.133129244, 40.778387574],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3002",
      },
    },
    {
      type: "Feature",
      id: "sm0a813ce2",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.130172084, 40.772474189],
            [-74.138917442, 40.769859992],
            [-74.136051101, 40.764360067],
            [-74.127406909, 40.766944238],
            [-74.130172084, 40.772474189],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3001",
      },
    },
    {
      type: "Feature",
      id: "sme912b9ab",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.127406909, 40.766944238],
            [-74.136051101, 40.764360067],
            [-74.133018135, 40.758539926],
            [-74.12448099, 40.76109232],
            [-74.127406909, 40.766944238],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3000",
      },
    },
    {
      type: "Feature",
      id: "sm66c85099",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.12448099, 40.76109232],
            [-74.133018135, 40.758539926],
            [-74.130157967, 40.753050911],
            [-74.12172177, 40.755573332],
            [-74.12448099, 40.76109232],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2999",
      },
    },
    {
      type: "Feature",
      id: "smb0ffe4ca",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.12172177, 40.755573332],
            [-74.130157967, 40.753050911],
            [-74.127097239, 40.747176494],
            [-74.118769068, 40.749666836],
            [-74.12172177, 40.755573332],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2998",
      },
    },
    {
      type: "Feature",
      id: "sm950ebedb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.118769068, 40.749666836],
            [-74.127097239, 40.747176494],
            [-74.124099963, 40.741423357],
            [-74.11583397, 40.743795034],
            [-74.118769068, 40.749666836],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2997",
      },
    },
    {
      type: "Feature",
      id: "sm4492a9cc",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.11583397, 40.743795034],
            [-74.124099963, 40.741423357],
            [-74.121155472, 40.735771053],
            [-74.112993954, 40.738112954],
            [-74.11583397, 40.743795034],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2996",
      },
    },
    {
      type: "Feature",
      id: "sm1fddbd13",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.112993954, 40.738112954],
            [-74.121155472, 40.735771053],
            [-74.118142602, 40.729986991],
            [-74.110130479, 40.732383448],
            [-74.112993954, 40.738112954],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2995",
      },
    },
    {
      type: "Feature",
      id: "smb46a8abe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.110130479, 40.732383448],
            [-74.118142602, 40.729986991],
            [-74.115207019, 40.72435082],
            [-74.107256561, 40.726632551],
            [-74.110130479, 40.732383448],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2994",
      },
    },
    {
      type: "Feature",
      id: "sm0c066c8e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.107256561, 40.726632551],
            [-74.115207019, 40.72435082],
            [-74.112238673, 40.71865126],
            [-74.104434925, 40.720985789],
            [-74.107256561, 40.726632551],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2993",
      },
    },
    {
      type: "Feature",
      id: "sm592d9ca4",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.104434925, 40.720985789],
            [-74.112238673, 40.71865126],
            [-74.109242741, 40.712898238],
            [-74.101544733, 40.715201334],
            [-74.104434925, 40.720985789],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2992",
      },
    },
    {
      type: "Feature",
      id: "sm12c6aded",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.101544733, 40.715201334],
            [-74.109242741, 40.712898238],
            [-74.106158099, 40.706974347],
            [-74.098568961, 40.709245074],
            [-74.101544733, 40.715201334],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2991",
      },
    },
    {
      type: "Feature",
      id: "sm33b3f522",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.098568961, 40.709245074],
            [-74.106158099, 40.706974347],
            [-74.103220015, 40.701331424],
            [-74.095734575, 40.703571314],
            [-74.098568961, 40.709245074],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2990",
      },
    },
    {
      type: "Feature",
      id: "sm8b68bc0e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.095734575, 40.703571314],
            [-74.103220015, 40.701331424],
            [-74.100234505, 40.695596924],
            [-74.092854436, 40.697805474],
            [-74.095734575, 40.703571314],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2989",
      },
    },
    {
      type: "Feature",
      id: "smf79c9e71",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.092854436, 40.697805474],
            [-74.100234505, 40.695596924],
            [-74.097234504, 40.689707985],
            [-74.089776109, 40.691892373],
            [-74.092854436, 40.697805474],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2988",
      },
    },
    {
      type: "Feature",
      id: "smd9997516",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.089776109, 40.691892373],
            [-74.097234504, 40.689707985],
            [-74.094379844, 40.684103864],
            [-74.086867247, 40.686304311],
            [-74.089776109, 40.691892373],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2987",
      },
    },
    {
      type: "Feature",
      id: "sma67ac776",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.086867247, 40.686304311],
            [-74.094379844, 40.684103864],
            [-74.091472763, 40.678396348],
            [-74.083926813, 40.680655122],
            [-74.086867247, 40.686304311],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2986",
      },
    },
    {
      type: "Feature",
      id: "smb0a32e79",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.083926813, 40.680655122],
            [-74.091472763, 40.678396348],
            [-74.090029876, 40.675563325],
            [-74.082456608, 40.677830372],
            [-74.083926813, 40.680655122],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2985",
      },
    },
    {
      type: "Feature",
      id: "sm92ef65ae",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.082456608, 40.677830372],
            [-74.090029876, 40.675563325],
            [-74.088602433, 40.672760506],
            [-74.080980138, 40.674993463],
            [-74.082456608, 40.677830372],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2984",
      },
    },
    {
      type: "Feature",
      id: "sm016f3d1f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.080980138, 40.674993463],
            [-74.088602433, 40.672760506],
            [-74.087074815, 40.669760861],
            [-74.079423515, 40.672002417],
            [-74.080980138, 40.674993463],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2983",
      },
    },
    {
      type: "Feature",
      id: "sm4988cbf6",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.079423515, 40.672002417],
            [-74.087074815, 40.669760861],
            [-74.085598332, 40.666861498],
            [-74.077918998, 40.669111364],
            [-74.079423515, 40.672002417],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2982",
      },
    },
    {
      type: "Feature",
      id: "sm2702e193",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077918998, 40.669111364],
            [-74.085598332, 40.666861498],
            [-74.084172984, 40.664062428],
            [-74.076466586, 40.666320318],
            [-74.077918998, 40.669111364],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2981",
      },
    },
    {
      type: "Feature",
      id: "sm942f8839",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.076466586, 40.666320318],
            [-74.084172984, 40.664062428],
            [-74.0827516, 40.661271026],
            [-74.075018214, 40.663536918],
            [-74.076466586, 40.666320318],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2980",
      },
    },
    {
      type: "Feature",
      id: "sm57591a57",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.075018214, 40.663536918],
            [-74.0827516, 40.661271026],
            [-74.081334422, 40.658487768],
            [-74.073574128, 40.660761639],
            [-74.075018214, 40.663536918],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2979",
      },
    },
    {
      type: "Feature",
      id: "sm9b38c706",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.073574128, 40.660761639],
            [-74.081334422, 40.658487768],
            [-74.079824106, 40.655521464],
            [-74.072057618, 40.657847049],
            [-74.073574128, 40.660761639],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2978",
      },
    },
    {
      type: "Feature",
      id: "sm74349267",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.072057618, 40.657847049],
            [-74.079824106, 40.655521464],
            [-74.078319909, 40.652567047],
            [-74.070524943, 40.654901262],
            [-74.072057618, 40.657847049],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2977",
      },
    },
    {
      type: "Feature",
      id: "sm0e1bf06b",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.070524943, 40.654901262],
            [-74.078319909, 40.652567047],
            [-74.076850537, 40.649680903],
            [-74.069027752, 40.65202355],
            [-74.070524943, 40.654901262],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2976",
      },
    },
    {
      type: "Feature",
      id: "sm6e01f609",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.069027752, 40.65202355],
            [-74.076850537, 40.649680903],
            [-74.075414468, 40.646860053],
            [-74.067564495, 40.649210941],
            [-74.069027752, 40.65202355],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2975",
      },
    },
    {
      type: "Feature",
      id: "smfecbfb7f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.067564495, 40.649210941],
            [-74.075414468, 40.646860053],
            [-74.073951915, 40.643987057],
            [-74.066074252, 40.646346339],
            [-74.067564495, 40.649210941],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2974",
      },
    },
    {
      type: "Feature",
      id: "sm3417b9f8",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.066074252, 40.646346339],
            [-74.073951915, 40.643987057],
            [-74.072471949, 40.64107973],
            [-74.064566267, 40.643447507],
            [-74.066074252, 40.646346339],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2973",
      },
    },
    {
      type: "Feature",
      id: "sm8b231b78",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.064566267, 40.643447507],
            [-74.072471949, 40.64107973],
            [-74.07097381, 40.638136575],
            [-74.063039764, 40.640512951],
            [-74.064566267, 40.643447507],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2972",
      },
    },
    {
      type: "Feature",
      id: "smdfd78b64",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.063039764, 40.640512951],
            [-74.07097381, 40.638136575],
            [-74.069549096, 40.635337545],
            [-74.061588077, 40.6377221],
            [-74.063039764, 40.640512951],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2971",
      },
    },
    {
      type: "Feature",
      id: "smf5d82828",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.061588077, 40.6377221],
            [-74.069549096, 40.635337545],
            [-74.068085782, 40.632462558],
            [-74.060097058, 40.634855514],
            [-74.061588077, 40.6377221],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2970",
      },
    },
    {
      type: "Feature",
      id: "smc9ddc98f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.060097058, 40.634855514],
            [-74.068085782, 40.632462558],
            [-74.066627004, 40.62959636],
            [-74.058610661, 40.631997692],
            [-74.060097058, 40.634855514],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2969",
      },
    },
    {
      type: "Feature",
      id: "sm9fd50ddb",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.058610661, 40.631997692],
            [-74.066627004, 40.62959636],
            [-74.065208348, 40.626808875],
            [-74.057165146, 40.629218353],
            [-74.058610661, 40.631997692],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2968",
      },
    },
    {
      type: "Feature",
      id: "sm6e1441ef",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.057165146, 40.629218353],
            [-74.065208348, 40.626808875],
            [-74.063689754, 40.623824895],
            [-74.055617801, 40.626243094],
            [-74.057165146, 40.629218353],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2967",
      },
    },
    {
      type: "Feature",
      id: "smd3739983",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055617801, 40.626243094],
            [-74.063689754, 40.623824895],
            [-74.062305445, 40.621104664],
            [-74.05418384, 40.623485734],
            [-74.055617801, 40.626243094],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2966",
      },
    },
    {
      type: "Feature",
      id: "sm2791116e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.05418384, 40.623485734],
            [-74.062305445, 40.621104664],
            [-74.060830944, 40.618207081],
            [-74.052681343, 40.620596463],
            [-74.05418384, 40.623485734],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2965",
      },
    },
    {
      type: "Feature",
      id: "sm3a03f39d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.052681343, 40.620596463],
            [-74.060830944, 40.618207081],
            [-74.059265933, 40.615131496],
            [-74.051086617, 40.617529701],
            [-74.052681343, 40.620596463],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2964",
      },
    },
    {
      type: "Feature",
      id: "smd88a9a4f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.051086617, 40.617529701],
            [-74.059265933, 40.615131496],
            [-74.057887139, 40.612421752],
            [-74.049681644, 40.61482773],
            [-74.051086617, 40.617529701],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2963",
      },
    },
    {
      type: "Feature",
      id: "sm8226e09d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.049681644, 40.61482773],
            [-74.057887139, 40.612421752],
            [-74.056417835, 40.609534007],
            [-74.048184442, 40.611948269],
            [-74.049681644, 40.61482773],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2962",
      },
    },
    {
      type: "Feature",
      id: "sm97688cde",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.048184442, 40.611948269],
            [-74.056417835, 40.609534007],
            [-74.054973482, 40.606695178],
            [-74.046712665, 40.609117585],
            [-74.048184442, 40.611948269],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2961",
      },
    },
    {
      type: "Feature",
      id: "smf7c75e2c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.046712665, 40.609117585],
            [-74.054973482, 40.606695178],
            [-74.053514397, 40.603827271],
            [-74.045225875, 40.606257905],
            [-74.046712665, 40.609117585],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2960",
      },
    },
    {
      type: "Feature",
      id: "smbc59f91e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.045225875, 40.606257905],
            [-74.053514397, 40.603827271],
            [-74.052039521, 40.600928201],
            [-74.043722995, 40.603367153],
            [-74.045225875, 40.606257905],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2959",
      },
    },
    {
      type: "Feature",
      id: "smed4b6455",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.043722995, 40.603367153],
            [-74.052039521, 40.600928201],
            [-74.050521064, 40.597943336],
            [-74.042175707, 40.600390853],
            [-74.043722995, 40.603367153],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2958",
      },
    },
    {
      type: "Feature",
      id: "sme0c26bbe",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.042175707, 40.600390853],
            [-74.050521064, 40.597943336],
            [-74.049091136, 40.595132371],
            [-74.040718628, 40.597587954],
            [-74.042175707, 40.600390853],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2957",
      },
    },
    {
      type: "Feature",
      id: "sm2abca167",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.040718628, 40.597587954],
            [-74.049091136, 40.595132371],
            [-74.047643502, 40.59228648],
            [-74.039243507, 40.594750229],
            [-74.040718628, 40.597587954],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2956",
      },
    },

    {
      type: "Feature",
      id: "sm27442a8e",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.03778378, 40.591942],
            [-74.039243507, 40.594750231],
            [-74.047643502, 40.59228648],
            [-74.046210975, 40.58947017],
            [-74.044339118, 40.585789968],
            [-74.041420874, 40.586311428],
            [-74.041850028, 40.588201681],
            [-74.037867493, 40.588723122],
            [-74.036649821, 40.589760403],
            [-74.03778378, 40.591942],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2955",
      },
    },
    {
      type: "Feature",
      id: "smf0e9e03a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.055271847, 40.784461279],
            [-74.061811631, 40.797257469],
            [-74.078034294, 40.792467719],
            [-74.071466333, 40.779716533],
            [-74.055271847, 40.784461279],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3083",
      },
    },
    {
      type: "Feature",
      id: "smc0e1ba77",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.061811631, 40.797257469],
            [-74.055271847, 40.784461279],
            [-74.03878651, 40.789290891],
            [-74.04534329, 40.802119401],
            [-74.061811631, 40.797257469],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3082",
      },
    },
    {
      type: "Feature",
      id: "sm4addb02c",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.04534329, 40.802119401],
            [-74.03878651, 40.789290891],
            [-74.025040459, 40.793317722],
            [-74.025070126, 40.793382963],
            [-74.02438348, 40.794682548],
            [-74.026752191, 40.807607606],
            [-74.04534329, 40.802119401],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3081",
      },
    },
    {
      type: "Feature",
      id: "sm00ce7ae7",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.077210817, 40.815497917],
            [-74.067020303, 40.795719643],
            [-74.026752191, 40.807607606],
            [-74.030563291, 40.828397895],
            [-74.031850751, 40.828884986],
            [-74.077210817, 40.815497917],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2850",
      },
    },
    {
      type: "Feature",
      id: "sm1c724393",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.067020303, 40.795719643],
            [-74.077210817, 40.815497917],
            [-74.088224808, 40.812246962],
            [-74.078034294, 40.792467719],
            [-74.067020303, 40.795719643],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG2849",
      },
    },
    {
      type: "Feature",
      id: "sm947e671f",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.10930961, 40.806023002],
            [-74.104096156, 40.795903752],
            [-74.083011353, 40.802128661],
            [-74.088224808, 40.812246962],
            [-74.10930961, 40.806023002],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3085",
      },
    },
    {
      type: "Feature",
      id: "sm8c26d016",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.124739927, 40.789808484],
            [-74.129953381, 40.799928663],
            [-74.15084707, 40.793759974],
            [-74.145633616, 40.783638855],
            [-74.124739927, 40.789808484],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3087",
      },
    },
    {
      type: "Feature",
      id: "smd6a31e5a",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.129953381, 40.799928663],
            [-74.124739927, 40.789808484],
            [-74.104096156, 40.795903752],
            [-74.10930961, 40.806023002],
            [-74.129953381, 40.799928663],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3086",
      },
    },
    {
      type: "Feature",
      id: "sm04803d83",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.10271296, 40.770560774],
            [-74.113121731, 40.79093039],
            [-74.132959304, 40.785097514],
            [-74.133474287, 40.784187674],
            [-74.123818335, 40.765208209],
            [-74.122530875, 40.764753156],
            [-74.10271296, 40.770560774],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3084A",
      },
    },
    {
      type: "Feature",
      id: "sm0ffeccde",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.082307367, 40.776540081],
            [-74.092725862, 40.796926888],
            [-74.113121731, 40.79093039],
            [-74.10271296, 40.770560774],
            [-74.082307367, 40.776540081],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3084B",
      },
    },
    {
      type: "Feature",
      id: "sm5870912d",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.092725862, 40.796926888],
            [-74.082307367, 40.776540081],
            [-74.071466333, 40.779716533],
            [-74.083011353, 40.802128661],
            [-74.090049553, 40.800050824],
            [-74.089877735, 40.799716606],
            [-74.089872296, 40.799718208],
            [-74.088756499, 40.79809384],
            [-74.092725862, 40.796926888],
          ],
        ],
      },
      properties: {
        Unit_Number: "OG3084A",
      },
    },
  ],
};

export default geojsonData;
